import { render, staticRenderFns } from "./olderMember.vue?vue&type=template&id=35c91f84&scoped=true"
import script from "./olderMember.vue?vue&type=script&lang=js"
export * from "./olderMember.vue?vue&type=script&lang=js"
import style0 from "./olderMember.vue?vue&type=style&index=0&id=35c91f84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c91f84",
  null
  
)

export default component.exports